<template>
  <stack :column-min-width="350" :gutter-width="5" :gutter-height="5" monitor-images-loaded>
    <stack-item
      class="stack-item-vunsplash d-flex justify-center"
      v-for="(data, index) in fetchData"
      :key="index">
      <v-card
        class="_img-card-vunsplash"
        :elevation="0"
        tile
        :href="data.link.url"
        dark
      >
        <img
          :src="data.image.data + '&w=500'"
          gradient="rgba(0, 0, 0, .42), rgba(0, 0, 0, .42)"
          style="opacity: .8; width: 100%; height: auto; border: 1px solid #00000000 !important; padding: 0;"
        />
        <div class="centered">
          <component is="cover-category" :blockField="data" :blockProperty="sectionSelected.settings.style">
            <template slot="title">
              {{ data.title.data }}
            </template>
            <template slot="subtitle">
              {{ data.subtitle.data }}
            </template>
            <!--
            <template slot="link">
              {{ data.link.data }}
            </template>
            -->
          </component>
        </div>
      </v-card>
    </stack-item>
  </stack>
</template>
<script>
  import { Stack, StackItem } from 'vue-stack-grid'
  import section from '@fremcast/section/mixins/section';
  import video from '@fremcast/section/mixins/videos';
  import presentation from '@fremcast/section/mixins/presentation';
  import card from '@fremcast/section/mixins/card';
  export default {
    mixins: [
      section,
      video,
      presentation,
      card
    ],
    components: {
      Block: () => import("./Block"),
      Stack,
      StackItem
    }
  }
</script>

<style scoped>
  .stack-item-vunsplash {
    transition: transform 300ms;
  }
  .img-card-vunsplash::before {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    background-color: rgba(0, 0, 0, 0);
    outline: none;
    box-shadow: none !important;
  }

  .img-vunsplash {
    width: 100%;
    height: auto;
    margin: 0;
    transition: border-width 0.15s ease-out;
  }
  .overlay-vunsplash {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    margin: 0;
    padding: 0;
    transition: 0.5s ease;
  }

  .centered {
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: 18px;
  }

  .text-here {
    font-size: 14px;
    margin: 0;
    margin-top: 0.2em;
    line-height: 1;
    text-shadow: 1px 1px 0 rgb(0 0 0 / 35%), 1px 1px 5px rgb(0 0 0 / 50%);
  }
</style>
